module.exports = {"customerId":"dcb06386-2f8d-4755-bb5c-6af0ada8185f","organizationId":"Gralta","sentry":{"dsn":"https://628188608d63466f9eadb8dfb0addc70@o849476.ingest.sentry.io/6085900","tracesSampleRate":0.2},"dateFormat":"DD/MM/YYYY h:mm a"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 86
// module chunks = 0